/* eslint-disable consistent-return */
/* eslint-disable no-console */

import { useEffect, useRef, useState } from 'react';
import gqlService from '@modules/dashboard/services/graphql';

const INTERVAL_MS = 5 * 60 * 1000; // 5 minutes

const useOrderWatcher = () => {
    const intervalRef = useRef(null);
    const isFirstRun = useRef(true);
    const [showNotification, setShowNotification] = useState(false);
    const [unconfirmedCount, setUnconfirmedCount] = useState(0);

    const { data } = gqlService.getDashboardDataShipmentUnTotal();

    const checkAndNotify = async () => {
        try {
            const currentCount = data?.getDashboardData?.shipment_unconfirmed_total;

            if (currentCount !== undefined) {
                setUnconfirmedCount(currentCount);

                // Skip notification on first run
                if (isFirstRun.current) {
                    isFirstRun.current = false;
                    return;
                }

                // Show notification if there are unconfirmed orders
                if (currentCount > 0) {
                    setShowNotification(true);
                    // Play notification sound
                    const audio = new Audio('/assets/audio/notification.mpeg');
                    audio.play().catch((err) => console.log('Audio play failed:', err));
                }
            }
        } catch (error) {
            console.error('Error checking orders:', error);
        }
    };

    const handleCloseNotification = () => {
        setShowNotification(false);
    };

    useEffect(() => {
        // Initial check
        if (!isFirstRun.current) {
            checkAndNotify();
        } else {
            isFirstRun.current = false;
        }

        // Setup interval
        intervalRef.current = setInterval(() => {
            checkAndNotify();
        }, INTERVAL_MS);

        // Cleanup on unmount
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [data]);

    return {
        showNotification,
        unconfirmedCount,
        handleCloseNotification,
    };
};

export default useOrderWatcher;
